import { Injectable } from '@angular/core';
import * as moment from 'moment';
import jwtDecode from 'jwt-decode';
import { BehaviorSubject, Observable } from 'rxjs';
import { Usuario } from '../ecommerce-generico/interfaces/usuario.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private user: Usuario;
  private userProvider: BehaviorSubject<Usuario> = new BehaviorSubject(undefined);

  constructor() { }

  setLogueado(valor: boolean): void {
    sessionStorage.setItem('logueado', JSON.stringify(valor));
  }

  isLogueado(): boolean {
    return JSON.parse(sessionStorage.getItem('logueado') || 'false');
  }

  logout(): void {
    sessionStorage.removeItem('logueado');
  }

  getUser(): Usuario {
    return this.user;
  }

  setUser(user: Usuario): void {
    this.user = user;
  }

  getUserProvider(): Observable<Usuario> {
    return this.userProvider.asObservable();
  }

  /** Emite el usuario actual (this.user) a los suscriptores. */
  emitUsuarioActual(): void {
    this.userProvider.next(this.user);
  }

  /** Emite explícitamente "sin usuario", sin tocar this.user. */
  emitSinUsuario(): void {
    this.userProvider.next(undefined);
  }

  /**
   * Revisa si faltan 5 minutos para que expire el token del usuario logueado
   * @param token token del usuario
   */
  isUserTokenValid(token: string): boolean {
    const decoded = jwtDecode(token);
    const expirationDate = new Date(decoded['exp'] * 1000);
    const daste = moment().local(true).add(5, 'minutes').unix();
    const midate = new Date(daste * 1000);
    return !(expirationDate <= midate);
  }
}
